import {
  Row,
  Col,
  FormGroup,
  Label,
  CustomTextArea,
  Input,
} from '@polichat/flamboyant';
import { useState } from 'react';
import {
  LabelWithSpan,
  OptionsContainer,
} from '../../FormMessagesBuilder.styles';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function CreateFooterWaba({ onUpdate, initialValue, isEdit }) {
  const footerLabel = useGlotaT('spa.messageBuilder.footer.label');
  const footerDescription = useGlotaT('spa.messageBuilder.footer.description');
  const footerPlaceholder = useGlotaT('spa.messageBuilder.footer.placeholder');
  const footerVariableWarning = useGlotaT('spa.messageBuilder.footer.variableWarning');
  const [footerData, setFooterData] = useState(initialValue);

  const handleInputChange = ({ target: { name, value } }) => {
    setFooterData({
      ...footerData,
      [name]: value,
    });
    handleFooterData({
      ...footerData,
      [name]: value,
    });
  };

  const handleFooterData = (data) => {
    onUpdate(data);
  };

  return (
    <Row>
      <Col sm={12}>
        <FormGroup>
          <LabelWithSpan>
            <Label>
              {footerLabel}{' '}
              <span>
                {footerDescription}{' '}
              </span>
            </Label>
          </LabelWithSpan>
          <Input
            type="text"
            id="footer-message"
            name="text"
            placeholder={footerPlaceholder}
            value={footerData.text}
            onChange={handleInputChange}
            showCharCounter
            maxLength={60}
            disabled={isEdit}
          />
          <LabelWithSpan>
            <Label>
              <span>
                {footerVariableWarning}{' '}
              </span>
            </Label>
          </LabelWithSpan>
          <OptionsContainer></OptionsContainer>
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CreateFooterWaba;
